import VI_VN from './lang/vi_vn'
import EN_US from './lang/en_us'

export const LANGUAGE = {
  vi_VN: VI_VN,
  en_US: EN_US,
}
